<script lang="ts">
import { computed, defineComponent, onMounted } from "vue";
import tracking from "@/businesslogic/tracking/tracking";
import GevHeader from "@/layout/GevHeader.vue";
import GevFooter from "@/layout/GevFooter.vue";
import { useFormStore } from "@/businesslogic/stores/formStore";

export default defineComponent({
  name: "Fehler",
  props: {
    error: String,
  },
  components: { GevHeader, GevFooter },
  setup(props) {
    const { track } = tracking();
    const piniaStore = useFormStore();

    const fehlermeldung = computed(() => {
      return "leider trat " + (props.error ? "folgender Fehler auf: " + props.error : "ein Fehler auf.");
    });

    onMounted(() => {
      const produkt = piniaStore.state.verkaufsprodukt ? piniaStore.state.verkaufsprodukt.toLowerCase() : "";
      track(piniaStore.getSessionToken(piniaStore.state), "Fehler", "Fehlerseite_zeigen", piniaStore.state, {
        fehlergrund: props.error,
      });
      window.onpopstate = function () {
        piniaStore.resetState();
        piniaStore.storeInitialisieren(
          piniaStore.state.isMakler,
          piniaStore.state.isMaklerLink,
          "",
          undefined,
          produkt,
        );
        window.onpopstate = null;
      };
    });

    return { props, fehlermeldung };
  },
});
</script>

<template>
  <div id="page">
    <GevHeader produkt="Fehler" />

    <main class="o-container js-main-container u-bg-white" style="position: relative">
      <section class="u-bg-white o-container__remove u-pad-y-2">
        <div class="o-container">
          <h2 class="u-mar-t-0 u-mar-b-3 u-text-align-center">Fehler</h2>
          <p>
            Sehr geehrte Besucherin, sehr geehrter Besucher,<br /><br />
            {{ fehlermeldung }}
            <br /><br />
            Unser Online-Team sucht bereits nach einer Lösung.
            <br /><br />
            Ihre GEV
          </p>
        </div>
      </section>
    </main>

    <GevFooter />
  </div>
</template>
